import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const _get = async (doId, queryParam) => {
  const params = {
    type: queryParam.status,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/fleet-task/${doId}/history`,
    params: params,
  })

  return response?.data
}
export const get = (doId) => async (queryParam) => await _get(doId, queryParam)


export const showListDO = async (id, logId) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/fleet-task/${id}/history/${logId}/detail`,
  })

  return response?.data
}